// removed by extract-text-webpack-plugin
module.exports = {"THead":"classlist__THead__3sfQH","ParticipantList":"classlist__ParticipantList__1B-R5","Participant":"classlist__Participant__3rDwO","InSession":"classlist__InSession__FPZ2v"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ClassList/classlist.css
// module id = 874
// module chunks = 2